import { NgModule } from '@angular/core';
import { SemiPieChartComponent } from './semi-pie-chart.component';
import {SharedModule} from '../../_shared/shared.module';
import { PipeModule } from 'app/_pipe/pipe.module';

@NgModule({
  imports: [
    SharedModule,
    PipeModule.forRoot()
  ],
  declarations: [SemiPieChartComponent],
  exports: [SemiPieChartComponent]
})
export class SemiPieChartModule { }



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/_custom/semi-pie-chart/semi-pie-chart.module.ts